module.exports = __webpack_public_path__ + "img/chi-siamo-5.5efaaf6d.jpg";